/* eslint-disable */
import React, { useRef, useEffect } from 'react'
import { isInDomain } from 'AccountsUtils'
import { isInFlyinDomain } from 'AccountsUtils'
import { getWalletUrl } from '../../../utils/walletUtils'

const LoggedinProfileDropdown = ({ logout, hideProfileDropdown }) => {
  const wrapperRef = useRef(null)
  const handleClickOutside = event => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      hideProfileDropdown()
    }
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  })

  return (
    <ul
      ref={wrapperRef}
      className="listMenu userAccountMenu"
      id="userAccountMenu"
    >
      <li className="clearFix">
        <ul>
          <li className="userAccountCol accountTools">
            <ul>
              <li>
                <a
                  href={
                    isInFlyinDomain()
                      ? '/accounts/trips?chnl=Fly'
                      : '/accounts/trips'
                  }
                  className="forceHttps"
                  appref="true"
                  onMouseDown={e => {
                    console.log('onClick', e)
                    e.target.preventDefault()
                    e.target.stopPropagation()
                  }}
                >
                  <i className="iconSprite icoTrips">&nbsp;</i>
                  Trips
                </a>
              </li>
              <li>
                <a
                  href="/account/travellers"
                  className="forceHttps"
                  appref="true"
                  onMouseDown={e => {
                    console.log('onClick')
                    e.target.preventDefault()
                    e.target.stopPropagation()
                  }}
                >
                  <i className="iconSprite icoTravellers">&nbsp;</i>
                  Travellers
                </a>
              </li>
              <li className="separator" />
              <li>
                <a
                  href={getWalletUrl()}
                  className="forceHttps"
                  appref="true"
                  onMouseDown={e => {
                    console.log('onClick')
                    e.target.preventDefault()
                    e.target.stopPropagation()
                  }}
                >
                  <i className="iconSprite icoWallet">&nbsp;</i>
                  {isInDomain() ? 'Cleartrip Wallet' : 'Wallet'}
                </a>
              </li>
              <li>
                <a
                  href="/accounts/expressway"
                  className="forceHttps"
                  appref="true"
                  onMouseDown={e => {
                    console.log('onClick')
                    e.target.preventDefault()
                    e.target.stopPropagation()
                  }}
                >
                  <i className="iconSprite icoExpressway">&nbsp;</i>
                  Expressway
                </a>
              </li>
            </ul>
          </li>
          <li className="userAccountCol quickTools">
            <ul>
              <li className="quickToolsHead">Quick Tools</li>
              <li>
                <a
                  href={
                    isInFlyinDomain()
                      ? '/accounts/trips?src=qtcf&amp;chnl=Fly'
                      : '/accounts/trips?src=qtcf'
                  }
                  className="forceHttps"
                  appref="true"
                  onMouseDown={e => {
                    console.log('onClick')
                    e.target.preventDefault()
                    e.target.stopPropagation()
                  }}
                >
                  <i className="iconSprite icoCancel">&nbsp;</i>
                  Cancellations
                </a>
              </li>
              <li>
                <a
                  href={
                    isInFlyinDomain()
                      ? '/accounts/trips?src=qtcf&amp;chnl=Fly'
                      : '/accounts/trips?src=qtcf'
                  }
                  className="forceHttps"
                  appref="true"
                  onMouseDown={e => {
                    console.log('onClick')
                    e.target.preventDefault()
                    e.target.stopPropagation()
                  }}
                >
                  <i className="iconSprite icoChange">&nbsp;</i>
                  Change flight
                </a>
              </li>
              <li className="separator" />
              <li>
                <a
                  href="/ticket?src=qtpr"
                  className="forceHttps"
                  appref="true"
                  onMouseDown={e => {
                    console.log('onClick')
                    e.target.preventDefault()
                    e.target.stopPropagation()
                  }}
                >
                  <i className="iconSprite icoTicket">&nbsp;</i>
                  Print ticket
                </a>
              </li>
              <li>
                <a
                  href="/voucher"
                  className="forceHttps"
                  appref="true"
                  onMouseDown={e => {
                    console.log('onClick')
                    e.target.preventDefault()
                    e.target.stopPropagation()
                  }}
                >
                  <i className="iconSprite icoHotelVoucher">&nbsp;</i>
                  Print hotel voucher
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li className="miscLinks">
        <ul>
          <li>
            <a
              href="/account/profile"
              className="forceHttps"
              appref="true"
              onMouseDown={e => {
                console.log('onClick')
                e.target.preventDefault()
                e.target.stopPropagation()
              }}
            >
              Profile
            </a>
          </li>
          <li>
            <a
              href="/account/settings"
              className="forceHttps"
              appref="true"
              onMouseDown={e => {
                console.log('onClick')
                e.target.preventDefault()
                e.target.stopPropagation()
              }}
            >
              Settings
            </a>
          </li>
          <li>
            <a
              href="javascript:void(0);"
              className="forceHttps"
              id="global_signout"
              onMouseDown={e => {
                console.log('onClick')
                e.target.preventDefault()
                e.target.stopPropagation()
              }}
              onClick={logout}
            >
              Signout
            </a>
          </li>
        </ul>
      </li>
    </ul>
  )
}
export default LoggedinProfileDropdown
